import React from "react";
import { FileX } from "lucide-react";

const NoData = ({
  title = "No data available",
  message = "There is nothing to show here yet.",
  icon: Icon = FileX,
  className = "",
}) => {
  return (
    <div
      className={`w-full py-12 flex flex-col items-center justify-center text-center ${className}`}
    >
      <div className="p-4 rounded-full bg-gray-100 dark:bg-primary/5 border border-gray-200 dark:border-gray-700">
        <Icon className="h-10 w-10 text-primary dark:text-primary" />
      </div>

      <h3 className="mt-4 text-lg font-semibold text-gray-900 dark:text-gray-100">
        {title}
      </h3>

      <p className="mt-1 text-gray-500 dark:text-gray-400 max-w-sm">
        {message}
      </p>
    </div>
  );
};

export default NoData;
